import React from "react";
import ImageCompressor from "../components/ImageCompressor";

export default function ReductionPage() {
  return (
    <main style={{ maxWidth: 900, margin: "0 auto" }}>
      <h1>Réduction</h1>
      <ImageCompressor />
    </main>
  );
}
